<template>
  <div>

    <p>
      Subreddit:
      r/<input class="border-b" placeholder="subreddit" v-model="subreddit" v-on:keyup.enter="analyze">
      Content:
      <button class="toolBtn border" :class="{selected: content === 'title'}" @click="content = 'title'">title</button>
      <button class="toolBtn border" :class="{selected: content === 'body'}" @click="content = 'body'">body</button>
    </p>
    <p>
      Listing type:
      <button class="toolBtn border" :class="{selected: listing === 'top'}" @click="listing = 'top'">top</button>
      <button class="toolBtn border" :class="{selected: listing === 'controversial'}" @click="listing = 'controversial'">controversial</button>
      <button class="toolBtn border" :class="{selected: listing === 'hot'}" @click="listing = 'hot'">hot</button>
      <button class="toolBtn border" :class="{selected: listing === 'new'}" @click="listing = 'new'">new</button>
      <button class="toolBtn border" :class="{selected: listing === 'rising'}" @click="listing = 'rising'">rising</button>
    </p>
    <p>
      Timeframe:
      <button class="toolBtn border" :class="{selected: timeframe === 'hour'}" @click="timeframe = 'hour'">hour</button>
      <button class="toolBtn border" :class="{selected: timeframe === 'day'}" @click="timeframe = 'day'">day</button>
      <button class="toolBtn border" :class="{selected: timeframe === 'week'}" @click="timeframe = 'week'">week</button>
      <button class="toolBtn border" :class="{selected: timeframe === 'month'}" @click="timeframe = 'month'">month</button>
      <button class="toolBtn border" :class="{selected: timeframe === 'year'}" @click="timeframe = 'year'">year</button>
      <button class="toolBtn border" :class="{selected: timeframe === 'all'}" @click="timeframe = 'all'">all</button>
    </p>
    <p>
      Weighting:
      <button class="toolBtn border" :class="{selected: weighting === 'entry'}" @click="weighting = 'entry'">by entries</button>
      <button class="toolBtn border" :class="{selected: weighting === 'votes'}" @click="weighting = 'votes'">log(votes)</button>
      <button class="toolBtn border" :class="{selected: weighting === 'comments'}" @click="weighting = 'comments'">log(comments)</button>
    </p>
    <p><button class="toolBtn" @click="analyze">Analyze</button> (click on a word in the word-cloud to remove it.)</p>
    <vue-word-cloud style="height: 480px;width: 640px;" :words="words" :color="color" font-family="Roboto">
      <template slot-scope="{text, weight, word}">
        <div :title="weight" style="cursor: pointer;" @click="onWordClick(word)">
          {{ text }}
        </div>
      </template>
    </vue-word-cloud>

  </div>
</template>

<style scoped>
.toolBtn {
  @apply p-1 bg-gray-300 rounded ml-1;
}
.selected {
  @apply border-primaryColor;
}
</style>

<script>
import axios from 'axios';
import VueWordCloud from 'vuewordcloud';
import Chance from 'chance';

const chance = new Chance();

export default {
  name: 'key',
  layout: 'channelPage',
  components: {
    [VueWordCloud.name]: VueWordCloud,
  },
  data() {
    return {
      subreddit: '',
      listing: 'new',
      timeframe: 'hour',
      content: 'title',
      weighting: 'entry',
      words: [['click', 1], ['analyze', 1]],
    };
  },
  computed: {
    color() {
      return () => chance.pickone(['#ffd077', '#3bc4c7', '#3a9eea', '#ff4e69', '#461e47']);
    },
  },
  methods: {
    onWordClick(word) {
      this.words = this.words.filter((weight) => {
        if (weight[0] === word[0]) return false;
        return true;
      });
    },
    async analyze() {
      if (this.subreddit === '') {
        this.words = [['need', 1], ['subreddit', 1]];
        return;
      }
      this.words = [['loading', 1], ['data', 1]];
      this.skipWords = {};

      const isRunningOnLocalhost = window.location.hostname.match(/localhost/);
      let svcUrl = 'https://app.implicit.io/';
      if (isRunningOnLocalhost) svcUrl = 'http://127.0.0.1:3000/';
      svcUrl += 'reddit-analyzer';

      const resp = await axios.get(`${svcUrl}`, {
        params: {
          subreddit: this.subreddit,
          listing: this.listing,
          timeframe: this.timeframe,
          content: this.content,
          weighting: this.weighting,
        },
      });
      // console.log(resp.data.weights);
      this.words = resp.data.weights;
      console.log(`Loaded: ${resp.data.entries} entries`);
    },
  },
  async created() {
    // console.log(this.$route);
    if (this.$route.hash) {
      this.subreddit = this.$route.hash.substring(1); // use 1 to drop the '#'
    }
  },
};
</script>
